/* Nice Shot — Recently viewed (client-side, localStorage).
   Captures the current PDP product and renders a re-find row on the PDP +
   collection. Self-contained, no deps. Hidden until there is something to show. */
(function () {
  var KEY = 'ns_recently_viewed_v1';
  var MAX = 8;   // how many we remember
  var SHOW = 4;  // how many we render (matches the 4-across 'You might also like' grid)

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function run() {
    // 1. Capture the current PDP product (if present) into the front of the list.
    var cur = document.querySelector('[data-ns-rv-current]');
    if (cur) {
      try {
        var p = JSON.parse(cur.textContent);
        if (p && p.id) {
          var list = read().filter(function (x) { return String(x.id) !== String(p.id); });
          list.unshift(p);
          write(list.slice(0, MAX));
        }
      } catch (e) {}
    }

    // 2. Render every recently-viewed section on the page.
    var sections = document.querySelectorAll('[data-ns-rv]');
    Array.prototype.forEach.call(sections, function (sec) {
      var currentId = sec.getAttribute('data-current-id');
      var grid = sec.querySelector('[data-ns-rv-grid]');
      if (!grid) return;
      var items = read().filter(function (x) {
        return String(x.id) !== String(currentId);
      }).slice(0, SHOW);
      if (!items.length) return;
      // Mirrors snippets/ns-product-card.liquid: photo tile, then a brand + price top line,
      // then the title. Same classes as the real card so it inherits the card's styling.
      grid.innerHTML = items.map(function (x) {
        var img = x.image
          ? '<img class="ns-card__img" src="' + esc(x.image) + '" alt="" loading="lazy" width="600" height="600">'
          : '<span class="ns-card__img ns-card__img--placeholder"></span>';
        return '<a class="ns-card ns-rv__card" href="' + esc(x.url) + '">' +
          '<span class="ns-card__media">' + img + '</span>' +
          '<span class="ns-card__body">' +
            '<span class="ns-card__topline">' +
              (x.brand ? '<span class="ns-card__brand">' + esc(String(x.brand).toUpperCase()) + '</span>' : '<span class="ns-card__brand"></span>') +
              '<span class="ns-card__price">' + esc(x.price) + '</span>' +
            '</span>' +
            '<span class="ns-card__title">' + esc(x.title) + '</span>' +
          '</span>' +
        '</a>';
      }).join('');
      sec.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
